import React from 'react';
import { useAuthRedirect } from './useAuthRedirect';
import { Routes } from '@xolv-mybrightlink/common';

export const Authenticated = (props: { children: React.ReactNode }) => {
  useAuthRedirect('UNAUTHENTICATED', Routes.login);
  return props.children;
};
